import { isNullish } from 'remeda';
import { PLATFORM_PARTNER_ID } from 'src/constants/platform';
import { Macro, useCurrentUserProfile, useGroupRules, UserGroupRules } from 'src/graphql';

const isPlatformPartner = (partnerId: number | null | undefined) =>
  isNullish(partnerId) || partnerId === PLATFORM_PARTNER_ID;

/** Who may manage macros for the conversation's partner, and which partner new ones belong to. */
export const useMacrosAccess = (contextPartnerId: number | null) => {
  const { checkValidity } = useGroupRules();
  const { user } = useCurrentUserProfile();

  const canManageMacros = checkValidity([UserGroupRules.AccessToManageMacros]);
  const canEditPlatformMacros =
    canManageMacros &&
    user?.partnerId === PLATFORM_PARTNER_ID &&
    checkValidity([UserGroupRules.Admin, UserGroupRules.SuperAdmin]);
  const currentUserId = user?.id;

  const canEditMacro = (macro: Macro) =>
    canEditPlatformMacros ||
    !isPlatformPartner(macro.partnerId) ||
    Boolean(currentUserId && macro.createdBy === currentUserId);

  return {
    canManageInContext: isPlatformPartner(contextPartnerId)
      ? canEditPlatformMacros
      : canManageMacros,
    canEditPlatformMacros,
    canEditMacro,
    currentUserId,
    resolvedPartnerId: isNullish(contextPartnerId) ? PLATFORM_PARTNER_ID : contextPartnerId,
  };
};
